import { render } from "./designSwitchPreview.vue?vue&type=template&id=cbc4cb1e"
import script from "./designSwitchPreview.vue?vue&type=script&lang=js"
export * from "./designSwitchPreview.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__